import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from '$'
import axios from 'axios';
import { Input, Button,DatePicker,message} from 'antd';
/** PERSONAL */
import API from '../../../../API/api';
import moment from 'moment'


class SetTagDetail extends Component {
    state = {
        exportStartTime:'',
        exportEndTime:'',

    }
    componentWillMount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }
    onStartChange = (value) => {
        this.setState({exportStartTime:value});
    }

    onEndChange = (value) => {
        this.setState({exportEndTime:value});
    }
    exportQuestion = () => {
        let exportGo = ()=>{
            var form = $("<form>");   //定义一个form表单
            form.attr('style', 'display:none');   //在form表单中添加查询参数
            form.attr('target', '');
            form.attr('method', 'post');
            form.attr('action', API.QUESTION_MANAGE_EXPORT);
            var input1 = $('<input>');
            input1.attr('type', 'hidden');
            input1.attr('name', 'start_time');
            if(this.state.exportStartTime){
                input1.attr('value', this.state.exportStartTime.format('YYYY-MM-DD'));
            }
            var input2 = $('<input>');
            input2.attr('type', 'hidden');
            input2.attr('name', 'end_time');
            if(this.state.exportEndTime){
                input2.attr('value', this.state.exportEndTime.format('YYYY-MM-DD'));
            }
            $('body').append(form);  //将表单放置在web中
            form.append(input1);   //将查询参数控件提交到表单上
            form.append(input2);
            form.submit();
        }
        let data = {
            start_time:'',
            end_time:''
        }
        if(this.state.exportStartTime){
            data.start_time = this.state.exportStartTime.format('YYYY-MM-DD')
        }
        if(this.state.exportEndTime){
            data.end_time = this.state.exportEndTime.format('YYYY-MM-DD')
        }
        axios.post(API.QUESTION_MANAGE_EXPORT_CHECK, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                exportGo()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    render() {
        let disabledEndDate = (endValue) => {
            if(!endValue){return false}
            const startValue = this.state.exportStartTime;
            if (!startValue) {
                return endValue.valueOf() >= moment().valueOf();
            }
            return (endValue.valueOf() >= moment(startValue).add(31,'day').valueOf()||endValue.valueOf() <= moment(startValue).valueOf()||endValue.valueOf() >= moment().valueOf());
        }
        let disabledStartDate = (startValue) => {
            if(!startValue){return false}

            const endValue = this.state.exportEndTime;
            if (!endValue) {
                return startValue.valueOf() >= moment().valueOf();
            }
            return (startValue.valueOf() <= moment(endValue).subtract(31,'day').valueOf()||startValue.valueOf() >= moment(endValue).valueOf());
        }
        return (
            <div style={{fontSize:'14px',position:'relative'}}>
                <h2>题目导出</h2>
                <div style={{marginTop:'14px'}}>
                    <span>入库时间：</span>
                </div>
                <DatePicker
                    format="YYYY-MM-DD"
                    placeholder={'开始时间'}
                    style={{marginRight:20}}
                    onChange={this.onStartChange}
                    disabledDate={disabledStartDate}
                />
                <span style={{margin:'0 10px'}}>至</span>
                <DatePicker
                    format="YYYY-MM-DD"
                    placeholder={'结束时间'}
                    onChange={this.onEndChange}
                    disabledDate={disabledEndDate}
                />
                {
                    this.props.user.role_qstatistics &&
                    <Button style={{margin:'0 20px'}} type={'primary'} onClick={this.exportQuestion}>导出</Button>
                }

            </div>
        )
    }
}
const mapStateTopProps = state => {
    return {
        user: state.user,

    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(SetTagDetail);



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_export/question_export/view.js